import "./reports.scss"
import {FidgetSpinner, Circles} from "react-loader-spinner";

const ReportCard = ({children, label, isLoading, column = false, show = true}) => {
    if (!show) {
        return null;
    }

    return (
        <div className="card">
            <span className="label">{label}</span>
            <div className={column ? "childrenContainerColumn" : "childrenContainer"}>
                    {isLoading ? <Circles width={48} height={48}/> : children}
            </div>
        </div>
    )
}

export default ReportCard;